export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    $('.haven-navigation li.dropdown .nav-link').click(function (e) {
      if ($(window).width() < 1200) {
        var grandparent = $(this).next();
        if ($(this).hasClass('open1') && grandparent.hasClass('opened')) {
          document.location.href = this.href;
        } else {
          $(this).addClass('open1');
          $('#navbar-primary .navbar-nav').find('i').removeClass('opened');
          $(this).next('.dropdown-toggle1').click();
        }
      } else {
        location.href = this.href;
      }
      e.preventDefault();
    });

    $('li.dropdown > .dropdown-toggle1').on('click', function (e) {
      var current = $(this).next();
      var current1 = $(this);
      var grandparent = $(this).parent().parent();
      grandparent.find('.dropdown-menu:visible').not(current).removeClass('show1');
      grandparent.find('.dropdown-toggle1').not(current1).removeClass('opened');
      $(this).toggleClass('opened');
      current.toggleClass('show1');
      e.stopPropagation();
    });

    $('#house-slider').slick({
    centerMode: true,
          arrows: true,
    centerPadding: '0',
    slidesToShow: 3,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: true,
          centerMode: true,
          centerPadding: '0',
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          arrows: true,
          centerMode: true,
          centerPadding: '0',
          slidesToShow: 3,
        },
      },
    ],
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js